export default __webpack_public_path__ + "static/oasis2-9e546b29074b055c3585d94774f50480.svg";